<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :fullscreen="dialogLargeSize"
    transition="dialog-bottom-transition"
    :max-width="dialogLargeSize ? '' : '600px'"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary ml-4">
        <v-icon>add</v-icon>
        Crear
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense flat dark color="primary" v-if="!loading">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">{{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined>
          Reiniciar
        </v-btn>
        <v-btn type="submit" :form="formId" small light depressed>
          Guardar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-progress-circular
              v-if="loading"
              class="my-12 prd-dialog-spinner"
              :size="50"
              :color="
                ['uccess', 'error', 'warning', 'info'][
                  Math.floor(Math.random() * 4)
                ]
              "
              indeterminate
            />
            <form-vjsf
              :key="formKey"
              :formId="formId"
              :formData="formData"
              @getFormData="getFormData($event)"
              @submitForm="submitForm($event)"
            />
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    formVjsf: () => import("@/components/FormVjsf.vue"),
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    dialogLargeSize: {
      type: Boolean,
      required: true,
    },
    createTitle: {
      type: String,
      required: true,
    },
    modelKeyTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    formKey: 0,
    formData: {
      id: null,
      model: {},
      schema: {},
      options: {},
    },
    formId: "create_item",
    loading: null,
  }),
  methods: {
    cancel() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      this.formData.model = {}
    },
    getFormData() {
      this.loading = !this.loading
      this.service.newItem().then(response => {
        this.formData.schema = response.data.schema
        this.loading = !this.loading
      })
    },
    submitForm() {
      this.service
        .createItem(this.formData.model)
        .then(response => {
          if (response.status === 201) {
            this.$emit("createTableItem", response.data.id)
            this.dialog = false
            this.resetForm()

            this.$notify({
              type: "success",
              title: this.$store.state.commonText.notification.successTitle,
              text: this.$store.state.commonText.notification.successText,
            })
          }
        })
        .catch(error => {
          this.$notify({
            type: "error",
            title: this.$store.state.commonText.notification.errorTitle,
            text:
              this.$store.state.commonText.notification.errorText +
              "<br>" +
              error,
          })
        })
    },
  },
  computed: {
    dialogTitle() {
      return this.formData.model[this.modelKeyTitle]
        ? this.formData.model[this.modelKeyTitle]
        : this.createTitle
    },
  },
}
</script>

<style lang="scss" scoped></style>
